import { FC } from 'react';

import AchAdd from 'components/ach-add';
import { ACH_ADD_PAY } from 'utils/constants';

const ACHPay: FC = (): JSX.Element => <AchAdd intent={ACH_ADD_PAY} />;

export default ACHPay;
